import { useState, useRef, useEffect } from "react";

interface DropdownProps {
  id: string;
  options: string[];
  value: string;
  onChange: (val: string) => void;
  placeholder?: string;
}

const Dropdown: React.FC<DropdownProps> = ({
  id,
  options,
  value,
  onChange,
  placeholder = "",
}) => {
  const [open, setOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const handleClickOutside = (e: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(e.target as Node)
      ) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  return (
    <div className="relative" id={id} ref={containerRef}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="login-input flex items-center justify-between text-left"
        style={{
          color: value ? "var(--dark-blue)" : "#94a3b8",
          cursor: "pointer",
        }}
      >
        <span>{value || placeholder}</span>
        <svg
          className="flex-shrink-0"
          style={{
            width: 16,
            height: 16,
            transition: "transform 0.2s",
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
            color: "var(--dark-blue)",
          }}
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      </button>

      {open && (
        <div
          className="absolute z-50 w-full bg-white border-2 border-light-blue rounded-xl overflow-auto"
          style={{
            top: "calc(100% + 4px)",
            maxHeight: 220,
            boxShadow: "0 10px 30px 0 rgba(75,93,212,0.15)",
          }}
        >
          {options.map((opt) => (
            <button
              key={opt}
              type="button"
              onClick={() => {
                onChange(opt);
                setOpen(false);
              }}
              className="w-full text-left px-5 py-3 transition-colors"
              style={{
                fontFamily: "var(--font-primary)",
                fontSize: "0.875rem",
                color: "var(--blue)",
                fontWeight: 500,
                background: value === opt ? "#eef2fb" : "transparent",
              }}
              onMouseEnter={(e) =>
                ((e.currentTarget as HTMLButtonElement).style.background =
                  "#f1f6ff")
              }
              onMouseLeave={(e) =>
                ((e.currentTarget as HTMLButtonElement).style.background =
                  value === opt ? "#eef2fb" : "transparent")
              }
            >
              {opt}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default Dropdown;
